import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LwFormInput } from 'redesign';
import { PartnerUserFormData } from './partner-user-form.types';

type Props = {
  onSubmit: (data: PartnerUserFormData) => void;
  state: 'update' | 'create';
};

export const PartnerUserForm = ({ onSubmit, state }: Props) => {
  const { control, handleSubmit } = useFormContext<PartnerUserFormData>();
  const phoneNumberRegex = new RegExp('^\\+[0-9]+$');
  const { t } = useTranslation('hq-screen-specific');

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid item spacing={2} xs={6}>
        <Grid item xs={12}>
          <LwFormInput
            name="firstName"
            label={t('partners.users.form.first_name_label')}
            control={control}
            rules={{ required: t('partners.users.form.first_name_required') }}
          />
          <LwFormInput
            name="infix"
            label={t('partners.users.form.infix_label')}
            control={control}
          />
          <LwFormInput
            name="lastName"
            label={t('partners.users.form.last_name_label')}
            control={control}
            rules={{ required: t('partners.users.form.last_name_required') }}
          />
          {state === 'create' && (
            <LwFormInput
              name="email"
              label={t('partners.users.form.email_label')}
              inputType="email"
              control={control}
              rules={{ required: t('partners.users.form.email_required') }}
            />
          )}
          <LwFormInput
            name="phone"
            label={t('partners.users.form.phone_label')}
            inputType="tel"
            control={control}
            rules={{
              required: t('partners.users.form.phone_required'),
              pattern: {
                value: phoneNumberRegex,
                message: t('partners.users.form.phone_example'),
              },
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
};
